module.exports = __webpack_public_path__ + "static/media/1000px-Amazon_logo.svg.27261e4c.png";